import { render, staticRenderFns } from "./contactCard.vue?vue&type=template&id=48547e9d&lang=html&"
import script from "./contactCard.vue?vue&type=script&lang=js&"
export * from "./contactCard.vue?vue&type=script&lang=js&"
import style0 from "./contactCard.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports